import axios from "axios";
import { z } from "zod";
import { toast } from "../../components/ui/use-toast";
import { CircleCheckBig } from "lucide-react";
const baseUrl = process.env.REACT_APP_SERVER_URL;

export const getAllActions = async () => {
  try {
    const response = await axios.get(`${baseUrl}/api/actions`);
    return { actions: response.data.actions };
  } catch (error) {
    console.error(error);
  }
};

export const getAllPaginatedActions = async (
  page: number,
  keyword: string = ""
) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/actions/all?page=${page}&keyword=${encodeURIComponent(
        keyword
      )}`
    );
    return {
      actions: response.data.actions,
      count: response.data.count,
      totalPages: response.data.totalPages,
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const handleCreateAction = async (formData: any, navigate: Function) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
      },
    };

    const newsFormData = new FormData();

    for (const key in formData) {
      if (formData.hasOwnProperty(key) && key !== "image") {
        if (formData[key] !== undefined && formData[key] !== null) {
          if (Array.isArray(formData[key])) {
            newsFormData.append(key, JSON.stringify(formData[key]));
          } else {
            newsFormData.append(key, formData[key]);
          }
        }
      }
    }

    if (formData.image && Array.isArray(formData.image)) {
      formData.image.forEach((image: any, index: any) => {
        newsFormData.append(`image`, image.file);
      });
    }

    const response = await axios.post(
      `${baseUrl}/api/actions/`,
      newsFormData,
      config
    );

    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">{response.data.msg}</span>
        </div>
      ),
    });
    navigate("/admin-dashboard/initiative");
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: { [key: string]: string } = {};
      error.errors.forEach((err: any) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast({
          variant: "destructive",
          title: "Une erreur s'est produite.",
          description: error.response.data.message,
          className: "bg-red-500 border border-red-500",
        });
        return error.response.data.message;
      }
    }
  }
};

export const getActionBySlug = async (slug: string) => {
  try {
    const response = await axios.get(`${baseUrl}/api/actions/slug/${slug}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const handleUpdateAction = async (
  id: number,
  formData: any,
  navigate: Function
) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
      },
    };

    const formDataToSend = new FormData();

    for (const key in formData) {
      if (formData.hasOwnProperty(key) && key !== "image") {
        if (formData[key] !== undefined && formData[key] !== null) {
          if (Array.isArray(formData[key])) {
            formDataToSend.append(key, JSON.stringify(formData[key]));
          } else {
            formDataToSend.append(key, formData[key]);
          }
        }
      }
    }

    if (formData.image && Array.isArray(formData.image)) {
      formData.image.forEach((image: any, index: any) => {
        formDataToSend.append(`image`, image.file);
      });
    }

    const response = await axios.patch(
      `${baseUrl}/api/actions/${id}`,
      formDataToSend,
      config
    );

    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">
            {response.data.msg}
          </span>
        </div>
      ),
    });
    navigate("/admin-dashboard/initiative");
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: { [key: string]: string } = {};
      error.errors.forEach((err: any) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast({
          variant: "destructive",
          title: "Une erreur s'est produite.",
          description: error.response.data.message,
          className: "bg-red-500 border border-red-500",
        });
        return error.response.data.message;
      }
    }
  }
};

export const deleteAction = async (id: number) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
    const response = await axios.delete(`${baseUrl}/api/actions/${id}`, config);
    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">
            {response.data.message}
          </span>
        </div>
      ),
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getActionById = async (id: number) => {
  try {
    const response = await axios.get(`${baseUrl}/api/actions/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
